module.exports = __webpack_public_path__ + "img/logo.55b0f071.png";